import MenuFrame from "../frames/menu_frame";

function NewVendor() {
    return (
        <MenuFrame>
            NewVendor - Work in progress - UI
        </MenuFrame>
    );
}

export default NewVendor;
